import { LocationVarKey } from "@swivl-mono/types";

import { IF_ANY, IS_EQUAL, IS_NOT_EQUAL } from "../../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  InputRow,
  PageHeader,
  Section,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: LocationVarKey[] = [
  LocationVarKey.VoicePaymentHistoryMessage,
  LocationVarKey.VoiceSendPaymentHistoryText,
  LocationVarKey.VoicePaymentHistoryTextMessage,
  LocationVarKey.VoiceForwardPaymentHistory,
  LocationVarKey.VoicePaymentHistoryEscalateTo,
  LocationVarKey.VoicePaymentHistoryPhoneNumber
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page}>Payment History</PageHeader>
      <TextAreaRow {...page} marginTop label=" Voice Message" keyName={LocationVarKey.VoicePaymentHistoryMessage} />
      <SwitchRow {...page} keyName={LocationVarKey.VoiceSendPaymentHistoryText} label="Send SMS" />
      <TextAreaRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.VoiceSendPaymentHistoryText, "1")}
        marginTop
        label=" SMS Message"
        keyName={LocationVarKey.VoicePaymentHistoryTextMessage}
      />
      <SwitchRow {...page} keyName={LocationVarKey.VoiceForwardPaymentHistory} label="Escalate" />
      <DropdownRow
        {...page}
        hideIf={IS_EQUAL(LocationVarKey.VoiceForwardPaymentHistory, "0")}
        label="Send escalations to"
        marginTop
        keyName={LocationVarKey.VoicePaymentHistoryEscalateTo}
        options={[
          { label: "swivl Conversations", value: "swivl" },
          { label: "External Phone Number", value: "phone" }
        ]}
      />
      <Section
        {...page}
        hideIf={IF_ANY([
          IS_NOT_EQUAL(LocationVarKey.VoiceForwardPaymentHistory, "1"),
          IS_EQUAL(LocationVarKey.VoicePaymentHistoryEscalateTo, "swivl")
        ])}
      >
        <InputRow {...page} keyName={LocationVarKey.VoicePaymentHistoryPhoneNumber} label="External Phone Number" />
        <div className="cortexDescription">
          This is the direct line defined{" "}
          <a
            href="/properties/page/cortex/voice/voice-settings"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#FF5B02", textDecoration: "underline" }}
          >
            here
          </a>
          . Only overwrite this if you have a different direct line for this use case!
        </div>
      </Section>
    </>
  );
}
